/* eslint-disable prefer-const */
import Vue from "vue";
import { extend, uid } from "quasar";
import _set from "lodash.set";
import _get from "lodash.get";
import _has from "lodash.has";

const componentTypes = ["form", "layout", "standard"];

export const setCatalogData = (state, data) => {
    state.catalogData = data;
};

export const setErrorsClicked = (state, data) => {
    state.errorsClicked = data;
};

export const setLive = (state, value) => {
    state.live = value;
};

export const setWorkInProgress = (state, value) => {
    state.workInProgress = value;
};

export const setSubmitActionsList = (state, value) => {
    state.submitActionsList = value;
};

export const setFilteredOutcomes = (state, value) => {
    state.filteredOutcomes = value;
};

export const setIsSmallScreen = (state, value) => {
    state.isSmallScreen = value;
};

export const setLoadingInterfacesState = (store, state) => {
    store.loadingInterfaces = state;
};

export const setDesigner = (state, value) => {
    state.designer = value;
};

export const setReadonly = (state, value) => {
    state.readOnly = value;
};

export const setLegacyRenderer = (state, value) => {
    state.legacyRenderer = value;
};

export const updatePageReference = (state, reference) => {
    state.pageReference = reference;
};

export const setProcessInstanceId = (state, value) => {
    state.processInstanceId = value;
};

export const setActivityId = (state, value) => {
    state.activityId = value;
};

export const setTaskId = (state, value) => {
    state.taskId = value;
};
export const removeContainer = (state, guid) => {
    const index = state.containers.indexOf(guid);

    if (index !== -1) {
        state.containers.splice(index, 1);
    }
};

export const setSelectPath = (state, path) => {
    const { selectPath } = state;
    selectPath.splice(0, selectPath.length, ...path);
};

export const setActiveComponent = (state, data) => {
    state.activeComponent = data;
    if (!data) {
        setSelectPath(state, []);
    }
};
export const setFileNameWithDataModel = (state, data) => {
    state.fileNameWithDataModel = data;
};
export const setFilenameChange = (state, data) => {
    state.filenameChange = data;
};
export const emptyBody = (state, payload) => {
    const { guid = "body" } = payload || {};
    const refs = state.bodyReference;
    const emptyElement = root => {
        const body = refs[root] || [];

        if (body.length) {
            for (let loop = body.length - 1; loop > -1; loop--) {
                const { guid: guidLoop } = body[loop];

                removeContainer(state, guidLoop);
                emptyElement(guidLoop);
                body.pop();
            }
        }

        if (root !== "body") {
            removeContainer(state, root);
            delete state.data[root];
            delete state.properties[root];
            delete state.element[root];
            delete state.bodyReference[root];
        }
    };

    setActiveComponent(state, null);
    emptyElement(guid);
};

export const setContainers = (state, data) => {
    state.containers = data;
};

export const addContainer = (state, guid) => {
    state.containers.push(guid);
};

export const pushResetId = (state, guid) => {
    const index = state.resetId.indexOf(guid);

    if (index === -1) {
        state.resetId.push(guid);
    }
};

export const popResetId = (state, guid) => {
    const index = state.resetId.indexOf(guid);

    if (index !== -1) {
        state.resetId.splice(index, 1);
    }
};

export const cleanResetId = (state) => {
    state.resetId = [];
};

export const setData = (state, data) => {
    state.data = data || {};
};

export const latestVersion = (state, id) => {
    state.latestVersion = id;
};

export const setAppInterfaces = (state, data) => {
    state.appInterfaces = (data || []).sort((firsInt, secondInt) => secondInt.name.localeCompare(firsInt.name));
};

export const addAppInterface = (state, data) => {
    state.appInterfaces.push(data);
};

export const removeFragment = (state, guid) => {
    if (state.fragments.hasOwnProperty(guid)) {
        Vue.delete(state.fragments, guid);
    }
};

export const removeAppInterface = (state, guid) => {
    let allOk = true;
    const appInterfaceIndex = state.appInterfaces.findIndex(interfaceEntry => interfaceEntry.id === guid);
    if (appInterfaceIndex !== -1) {
        const { id } = state.appInterfaces[appInterfaceIndex];
        removeFragment(state, id);
        state.appInterfaces.splice(appInterfaceIndex, 1);
    } else if (state.activeInterface === "draft") {
        state.appInterfaces.splice(-1);
    } else {
        allOk = false;
    }
    return allOk;
};

export const updateAppInterface = (state, payload) => {
    const { guid, data } = payload;
    const appInterfaceIndex = state.appInterfaces.findIndex(interfaceEntry => interfaceEntry.id === guid);
    state.appInterfaces.splice(appInterfaceIndex, 1, data);
    state.appInterfaces.sort((firsInt, secondInt) => secondInt.name.localeCompare(firsInt.name));
};

export const setSaveErrors = (state, value) => {
    state.saveErrors = value;
};

export const addComponentsPropertiesCategories = (state, payload) => {
    const { name, list } = payload;
    state.componentsPropertiesCategories[name] = list;
};

export const setSidebarBasicLoading = (state, data) => {
    state.sidebarLoading.basic = data;
};

export const rawDataModel = (state, rawData) => {
    state.raw.dataModel = rawData;
};

export const parsedFirstTime = (state, value) => {
    state.parsed.firstTime = value;
};

export const rawCoreAPIs = (state, rawData) => {
    state.raw.coreAPIs = rawData;
};

export const rawExternalAPIs = (state, rawData) => {
    state.raw.externalAPIs = rawData;
};

export const rawSystemVariables = (state, rawData) => {
    state.raw.systemVariables = rawData;
};

export const parsedCatalogData = (state, parsedData) => {
    state.parsed.catalogs = parsedData;
};

export const parsedModelClassesData = (state, parsedData) => {
    state.parsed.modelClasses = parsedData;
};

export const setSystemVariablesData = (state, parsedData) => {
    state.parsed.systemVariables = parsedData;
};

export const setAssistantVis = (state, payload) => {
    state.assistantVisibility = payload;
};

export const setAssistantForceOpen = (state, payload) => {
    state.assistantForceOpen = payload;
};

export const setAiActions = (state, payload) => {
    state.aiActions = payload;
};

export const parsedAPIsRawData = (state, parsedData) => {
    state.parsed.apis = {};
    Object.entries(parsedData).forEach(entry => {
        const [key, value] = entry;
        Vue.set(state.parsed.apis, key, value);
    });
};

export const setInterfaceModel = (state, payload) => {
    const { guid, dataModel } = payload;

    if (guid && dataModel) {
        state.interfaceModel[guid] = dataModel;
    }
};

export const setCurrentInterfaceModel = (state, payload) => {
    state.currentInterfaceModel = payload ? extend(true, {}, payload) : null;
};

export const setActiveInterface = (state, interfaceData, gType = "GUI") => {
    state.activeInterface = interfaceData;
    if (interfaceData && interfaceData.previewInterfaceProp && interfaceData.previewInterfaceProp.id) {
        state.activeInterface = interfaceData.guid;
        state.currentInterfaceProperties.type = interfaceData.previewInterfaceProp.type;
        state.currentInterfaceProperties.code = interfaceData.previewInterfaceProp.code;
        state.currentInterfaceProperties.description = interfaceData.previewInterfaceProp.description;
    } else {
        if (interfaceData && interfaceData !== "draft") {
            const properties = extend(true, {}, state.appInterfaces.find(interfaceEntry => interfaceEntry.id === interfaceData) || {});
            if (properties.id) {
                state.currentInterfaceProperties = extend(true, {}, properties);
            }
        } else {
            if (interfaceData === "draft") {
                let code = 0; let name = null; let nameNumber = null;
                if (state.appInterfaces && state.appInterfaces.length) {
                    for (let i = 0; i < state.appInterfaces.length; i++) {
                        if (state.appInterfaces[i].id) {
                            const subName = state.appInterfaces[i].name;
                            const subCode = state.appInterfaces[i].code;
                            if (subName.includes("Interface")) {
                                if (subName.slice(11, (subName.length - 1)) !== "") {
                                    nameNumber = Number(subName.slice(11, (subName.length - 1)));
                                } else {
                                    nameNumber = Number(subName.slice(10, (subName.length - 1)));
                                }
                                name = nameNumber >= name ? nameNumber + 1 : name;
                            }
                            if (subCode.includes("INTF")) {
                                const codeNumber = Number(subCode.slice(5, subCode.lenght));
                                code = codeNumber >= code ? codeNumber + 1 : code;
                            }
                        }
                    }
                }
                state.emptyInterface.name = name !== null ? `Interface (${name})` : "Interface";
                state.emptyInterface.code = `INTF_${code}`;
            } else {
                state.emptyInterface.name = "";
                state.emptyInterface.code = "";
            }

            state.currentInterfaceProperties = extend(true, {}, state.emptyInterface, { id: uid(), type: gType });
        }

        const { type, name, description, code } = state.currentInterfaceProperties;
        state.currentInterfaceProperties._details = { type, name, description, code };
    }
};

export const resetInterface = (state, param) => {
    const { guid, type } = param || {};

    setCurrentInterfaceModel(state, null);
    setActiveInterface(state, guid, type);
    // state.emptyInterface = { id: null, code: null, name: null, type: "GUI", description: null, processImage: null };

    emptyBody(state);
};

export const setProperties = (state, payload) => {
    if (payload) {
        if (payload.guid) {
            if (state.properties.hasOwnProperty(payload.guid)) {
                state.properties[payload.guid] = payload.properties;
            } else {
                Vue.set(state.properties, payload.guid, payload.properties);
            }
        } else {
            state.properties = payload.properties || {};
        }
    } else {
        state.properties = {};
    }
};
export const addSlot = (state, payload) => {
    const { parent, guid } = payload;

    if (!state.slots.hasOwnProperty(parent)) {
        Vue.set(state.slots, parent, []);
    }
    state.slots[parent].push(guid);
};

export const addSlotComponent = (state, payload) => {
    const { parent, guid = "", properties = {} } = payload;

    if (guid) {
        const guidSlot = `${parent}.${guid}`;
        const element = { guid: guidSlot };

        addContainer(state, guidSlot);
        Vue.set(state.bodyReference, guidSlot, []);

        element.body = state.bodyReference[element.guid];
        Vue.set(state.element, element.guid, element);

        state.bodyReference[parent].push(state.element[element.guid]);
        properties.__slot = true;
        properties.parent = parent;
        setProperties(state, { guid: element.guid, properties });

        addSlot({ parent, guid });
    } else {
        addSlot({ parent });
    }
};

export const addComponent = (state, payload) => {
    let parent; const {
        element, properties, to, near, fragment = false
    } = payload;
    const configProperties = state.components[properties.__component];
    const isFragment = properties.__component === "ctrl-fragment";
    const isWebSocket = properties.__component === "ctrl-websocket";
    const isSlot = properties.__component === "ctrl-slot";
    if (isWebSocket) {
        return;
    }

    if (configProperties.acceptNodes || configProperties.slots || isFragment) {
        Vue.set(state.bodyReference, element.guid, []);
        element.body = state.bodyReference[element.guid];
        if (configProperties.acceptNodes && !properties.__fragment) { addContainer(state, element.guid); }
    }

    Vue.set(state.element, element.guid, element);
    if (to && to !== "body") {
        const elementProps = state.properties[to];
        const componentProps = state.components[elementProps.__component];
        const parentFragment = elementProps.__component === "ctrl-fragment";

        if (componentProps.acceptNodes || (componentProps.slots && isSlot) || (fragment && parentFragment)) {
            parent = to;
        } else {
            parent = elementProps.parent || "body";
        }
        // parent = componentProps.acceptNodes ? to : (elementProps.parent || "body");
    } else {
        parent = "body";
    }

    if (near) {
        const parentElements = state.bodyReference[parent]; let
            last;

        if (parentElements.length) {
            last = parentElements[parentElements.length - 1];
            state.properties[last.guid].__generics.share = true;
        }
    }
    state.bodyReference[parent].push(state.element[element.guid]);

    properties.parent = parent === "body" ? false : parent;
    setProperties(state, { guid: element.guid, properties });
};

export const addToParent = (state, payload) => {
    const { guid, to } = payload;
    const parent = state.properties[guid].parent || "body";

    const index = state.bodyReference[parent].findIndex(element => element.guid === guid);
    if (index !== -1) {
        state.bodyReference[parent].splice(index, 1);
    }

    state.bodyReference[to || "body"].push(state.element[guid]);
    state.properties[guid].parent = to;
};

export const addBasicComponent = (state, payload) => {
    let componentType;
    const { name, settings } = payload;
    let isHidden = false;

    if (settings.type && componentTypes.includes(settings.type)) {
        componentType = settings.type;
    } else if (settings.type === "hidden") {
        isHidden = true;
    } else {
        componentType = "custom";
    }

    const trimSettings = { ...settings };
    delete trimSettings.files;

    trimSettings.name = name;

    if (!state.components.hasOwnProperty(trimSettings.componentName)) {
        state.components[trimSettings.componentName] = trimSettings;
        if (!isHidden) {
            state.sidebarComponents.basic[componentType].push(trimSettings);
        }
    }
};

export const removeComponent = (state, guid) => {
    let parent;
    const elementProperties = state.properties[guid];

    if (elementProperties.parent) {
        parent = elementProperties.parent;
    } else {
        parent = "body";
    }

    const index = state.bodyReference[parent].findIndex(element => element.guid === guid);
    if (index !== -1) {
        state.bodyReference[parent].splice(index, 1);
        emptyBody(state, { guid });
    }
};

export const addIssue = (state, issue) => {
    const date = new Date(); const h = date.getHours(); const m = date.getMinutes(); const
        s = date.getSeconds();
    state.issues.push(`[${h}:${m}:${s}] ${issue}`);
};

export const updateCollapseHistory = (state, payload) => {
    const { name, value } = payload;

    state.collapseHistory[name] = value;
};

export const clearCollapseHistory = (state) => {
    state.collapseHistory = {};
};

export const updateFutureValues = (state, payload) => {
    const { guid, data = [] } = payload;
    Vue.set(state.futureValues, guid, data);
};

export const updateChildPosition = (state, payload) => {
    const { parent, newIndex, oldIndex } = payload;
    const [element] = state.bodyReference[parent].splice(oldIndex, 1);

    state.bodyReference[parent].splice(newIndex, 0, element);
};

export const updateColor = (state, payload) => {
    const { color, value } = payload;
    state.colorValue[color].value = value;
};

export const updateLegacyElementState = (state, payload) => {
    const { guid, values } = payload;

    if (!state.legacyElementState.hasOwnProperty(guid)) {
        const searchElement = guid.includes(",") ? guid.split(",").pop() : guid;
        const properties = state.properties[searchElement];

        if (properties && properties.__generics) {
            const { display = true, readOnly = false, mandatory = false } = properties.__generics;

            Vue.set(state.legacyElementState, guid, {
                display, readOnly, mandatory, mandatoryShow: false
            });
        } else {
            console.log(`Could not find generic properties on component ${guid}`);
        }
    }

    Object.entries(values).forEach(([key, value]) => {
        if (state.legacyElementState[guid] && (state.legacyElementState[guid][key] !== value)) {
            state.legacyElementState[guid][key] = value;
        }
    });
};

export const resetElementState = (state) => {
    state.legacyElementState = {};
};
export const setGoToComponent = (state, payload) => {
    const { path } = payload;
    state.goToComponent = path;
};

export const setGoToPath = (state, path) => {
    state.goToPath = Object.keys(path).length ? path : null;
};

export const initElementState = (state, payload) => {
    const { elementState, properties } = state;
    const { ns, guid, values } = payload;
    const path = ns ? [ns, guid] : [guid];

    const props = properties[guid];
    const generics = props && props.__generics;

    if (!generics) {
        console.warn(`Could not find generic properties for component ${guid}`);
        return;
    }

    const { display = true, readOnly = false, mandatory = false } = generics;
    let parentReference;

    if (ns) {
        if (!elementState[ns]) {
            Vue.set(elementState, ns, {});
        }
        parentReference = elementState[ns];
    } else {
        parentReference = elementState;
    }

    Vue.set(parentReference, guid, {
        display, readOnly, mandatory, mandatoryShow: false
    });

    if (values) {
        const existingState = _get(elementState, path);

        Object.entries(values || {}).forEach(([key, value]) => {
            if (existingState[key] !== value) {
                existingState[key] = value;
            }
        });
    }
};

export const setElementState = (state, payload) => {
    const { elementState, properties } = state;
    const { ns, guid, values, isNew = false } = payload;
    const path = ns ? [ns, guid] : [guid];
    const hasExistingState = isNew || _has(elementState, path);

    if (isNew || !hasExistingState) {
        const props = properties[guid];
        const generics = props && props.__generics;

        if (!generics) {
            console.log(`Could not find generic properties for component ${guid}`);
            return;
        }

        const { display = true, readOnly = false, mandatory = false } = generics;
        let parentState;

        if (ns) {
            if (!elementState[ns]) {
                Vue.set(elementState, ns, {});
            }
            parentState = elementState[ns];
        } else {
            parentState = elementState;
        }

        Vue.set(parentState, guid, {
            display, readOnly, mandatory, mandatoryShow: false
        });
    }

    if (values) {
        const existingState = _get(elementState, path);

        Object.entries(values || {}).forEach(([key, value]) => {
            if (existingState[key] !== value) {
                existingState[key] = value;
            }
        });
    }
};

export const setRouteEnter = (state, value) => {
    state.routeEnter = value;
};

export const addGuidCodes = (state, payload) => {
    const { guid, code } = payload;

    if (guid && code) {
        Vue.set(state.guidToCode, guid, code);
        Vue.set(state.codeToGuid, code, guid);
    }
};

export const addEvent = (state, payload) => {
    const { key, guid } = payload;

    if (!state.events.hasOwnProperty(key)) { Vue.set(state.events, key, []); }
    if (!state.events[key].includes(guid)) { state.events[key].push(guid); }
};

export const addAutomatedIndex = (state, payload) => {
    let index; const
        { componentType, guid } = payload;

    if (state.indexPairs.hasOwnProperty(guid)) {
        index = state.indexPairs[guid];
    } else {
        if (!state.automatedIndex.hasOwnProperty(componentType)) {
            Vue.set(state.automatedIndex, componentType, -1);
        }

        index = ++state.automatedIndex[componentType];
        Vue.set(state.indexPairs, guid, index);
    }
};

export const addFragment = (state, payload) => {
    const { id, data, model = null } = payload;

    if (state.fragments.hasOwnProperty(id)) {
        if (model) {
            Vue.set(state.fragments, id, data || {});
        } else {
            const { interfaceInputModel, interfaceJson } = state.fragments[id];

            Vue.set(state.fragments, id, data || {});
            Vue.set(state.fragments[id], "interfaceInputModel", interfaceInputModel);
            Vue.set(state.fragments[id], "interfaceJson", interfaceJson);
        }
    } else {
        Vue.set(state.fragments, id, data || {});
    }

    if (model) {
        const { interfaceInputModel, interfaceJson } = model;
        Vue.set(state.fragments[id], "interfaceInputModel", interfaceInputModel);
        Vue.set(state.fragments[id], "interfaceJson", interfaceJson);
    }
};
export const rawSystemVariablesForTasksExport = (state, rawData) => {
    state.raw.systemVariablesForTasksExport = rawData;
};
export const rawSystemVariablesForInstancesExport = (state, rawData) => {
    state.raw.systemVariablesForInstancesExport = rawData;
};
export const setCurrentAddedComponent = (state, data) => {
    state.currentAddedComponent = data;
};

export const setRichTextCache = (state, payload) => {
    const { key, content, setPath } = payload;

    if (!key) { return; }

    if (key.includes(",")) {
        const path = key.split(",").slice(-2).reverse();
        _set(state.richTextCache, path, { content, setPath });
    } else {
        state.richTextCache[key] = { content, setPath };
    }
};

export const removeRichStoreEntry = (state, key) => {
    if (!key) { return; }

    if (state.richTextCache.hasOwnProperty(key)) {
        delete state.richTextCache[key];
    }
};

export const resetState = (state) => {
    const defaultState = () => ({
        designer: false,
        live: false,
        legacyRenderer: true,
        readOnly: false,
        qfDebug: false,
        pageReference: null,
        defaultGenerics: {
            display: true,
            readOnly: false,
            mandatory: false
        },
        defaultColors: [
            {
                label: "primary",
                value: "primary",
                theme: true
            },
            {
                label: "secondary",
                value: "secondary",
                theme: true
            },
            {
                label: "tertiary",
                value: "tertiary",
                theme: true
            },
            {
                label: "accent",
                value: "accent",
                theme: true
            },
            {
                label: "positive",
                value: "positive",
                theme: true
            },
            {
                label: "negative",
                value: "negative",
                theme: true
            },
            {
                label: "info",
                value: "info",
                theme: true
            },
            {
                label: "warning",
                value: "warning",
                theme: true
            },
            {
                label: "light",
                value: "light",
                theme: true
            },
            {
                label: "faded",
                value: "faded",
                theme: true
            },
            {
                label: "dark",
                value: "dark",
                theme: true
            },
            {
                label: "black",
                value: "black",
                theme: false
            },
            {
                label: "white",
                value: "white",
                theme: false
            },
            {
                label: "red",
                value: "red",
                theme: false
            },
            {
                label: "pink",
                value: "pink",
                theme: false
            },
            {
                label: "purple",
                value: "purple",
                theme: false
            },
            {
                label: "deep-purple",
                value: "deep-purple",
                theme: false
            },
            {
                label: "indigo",
                value: "indigo",
                theme: false
            },
            {
                label: "blue",
                value: "blue",
                theme: false
            },
            {
                label: "light-blue",
                value: "light-blue",
                theme: false
            },
            {
                label: "cyan",
                value: "cyan",
                theme: false
            },
            {
                label: "teal",
                value: "teal",
                theme: false
            },
            {
                label: "green",
                value: "green",
                theme: false
            },
            {
                label: "light-green",
                value: "light-green",
                theme: false
            },
            {
                label: "lime",
                value: "lime",
                theme: false
            },
            {
                label: "yellow",
                value: "yellow",
                theme: false
            },
            {
                label: "amber",
                value: "amber",
                theme: false
            },
            {
                label: "orange",
                value: "orange",
                theme: false
            },
            {
                label: "deep-orange",
                value: "deep-orange",
                theme: false
            },
            {
                label: "brown",
                value: "brown",
                theme: false
            },
            {
                label: "grey",
                value: "grey",
                theme: false
            },
            {
                label: "blue-grey",
                value: "blue-grey",
                theme: false
            }
        ],
        colorValue: {
            primary: {
                value: "#3E71D2",
                default: "#3E71D2",
                theme: true
            },
            secondary: {
                value: "#26A69A",
                default: "#26A69A",
                theme: true
            },
            tertiary: {
                value: "#212121",
                default: "#212121",
                theme: true
            },
            accent: {
                value: "#FFFFFF",
                default: "#FFFFFF",
                theme: true
            },
            positive: {
                value: "#21BA45",
                default: "#21BA45",
                theme: true
            },
            negative: {
                value: "#DB2828",
                default: "#DB2828",
                theme: true
            },
            info: {
                value: "#31CCEC",
                default: "#31CCEC",
                theme: true
            },
            warning: {
                value: "#F2C037",
                default: "#F2C037",
                theme: true
            },
            light: {
                value: "#BDBDBD",
                default: "#BDBDBD",
                theme: true
            },
            faded: {
                value: "#777",
                default: "#777",
                theme: true
            },
            dark: {
                value: "#424242",
                default: "#424242",
                theme: true
            },
            black: { value: "#000000" },
            white: { value: "#FFFFFF" },
            red: { value: "#F44336" },
            pink: { value: "#E91E63" },
            purple: { value: "#9C27B0" },
            "deep-purple": { value: "#673AB7" },
            indigo: { value: "#3F51B5" },
            blue: { value: "#2196F3" },
            "light-blue": { value: "#03A9F4" },
            cyan: { value: "#00BCD4" },
            teal: { value: "#009688" },
            green: { value: "#4CAF50" },
            "light-green": { value: "#8BC34A" },
            lime: { value: "#CDDC39" },
            yellow: { value: "#FFEB3B" },
            amber: { value: "#FFC107" },
            orange: { value: "#FF9800" },
            "deep-orange": { value: "#FF5722" },
            brown: { value: "#795548" },
            grey: { value: "#9E9E9E" },
            "blue-grey": { value: "#607D8B" }
        },
        aiActions: [],

        // == sidebar =======
        sidebarComponents: {
            basic: {
                layout: [],
                standard: [],
                form: [],
                custom: []
            }
        },
        sidebarLoading: {
            basic: true
        },
        loadingInterfaces: true,

        // designer components
        saveErrors: false,
        components: {},
        componentsPropertiesCategories: {},
        richTextCache: {},
        activeComponent: null,
        containers: [],
        automatedIndex: {},
        indexPairs: {},

        // Data model
        latestVersion: null,
        raw: {},
        parsed: {
            firstTime: true,
            apis: {}
        }, // { catalogs, modelClasses, apis, variables }

        // Interfaces
        currentInterfaceProperties: null,
        appInterfaces: [],
        activeInterface: null,
        interfaceModel: {},
        currentInterfaceModel: null,
        assistantVisibility: true,
        assistantForceOpen: false,
        emptyInterface: {
            id: null,
            code: null,
            name: null,
            type: "GUI",
            description: null,
            processImage: null
        },

        // interface variables
        routeEnter: false,
        bodyReference: {
            body: []
        },
        element: {},
        properties: {},
        fileNameWithDataModel: null,
        filenameChange: null,
        data: {},
        slots: {},
        legacyElementState: {},
        elementState: {},
        fragments: {},
        resetId: [],
        goToPath: null,

        // properties collapse history
        collapseHistory: {},

        // keep all issues here
        issues: [],
        errorsClicked: [],

        // functional interface
        goToComponent: "",
        selectPath: [],
        futureValues: {},
        processInstanceId: null,
        activityId: null,
        taskId: null,
        isSmallScreen: false,
        workInProgress: false,
        submitActionsList: [],
        filteredOutcomes: [],

        // events
        catalogData: {},
        guidToCode: {},
        codeToGuid: {},
        events: {},
        currentAddedComponent: null
    });

    Object.assign(state, defaultState());
};
